var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-manager"
  }, [(_vm.hasErrors) ? _c('div', {
    staticClass: "errors"
  }, [_vm._l((_vm.defaultOrganizationErrors), function(error) {
    return _c('div', {
      key: error,
      staticClass: "uk-alert-danger",
      attrs: {
        "uk-alert": ""
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('fields.default')))]), _vm._v("\n      " + _vm._s(error) + "\n    ")])
  }), _vm._v(" "), _vm._l((_vm.organizationErrors), function(error) {
    return _c('div', {
      key: error,
      staticClass: "uk-alert-danger",
      attrs: {
        "uk-alert": ""
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('fields.active')))]), _vm._v("\n      " + _vm._s(error) + "\n    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-divider uk-table-justify"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('fields.organization')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.selected')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.default')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entries), function(entry) {
    return _c('tr', {
      key: entry.organization.id
    }, [_c('td', [_vm._v(_vm._s(entry.organization.name))]), _vm._v(" "), _c('td', [_c('checkbox', {
      attrs: {
        "disabled": _vm.disabled,
        "value": entry.selected
      },
      on: {
        "change": function($event) {
          _vm.toggleSelectedOrganization(entry.organization)
        }
      }
    })], 1), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "disabled": _vm.isDisabledDefaultEntry(entry),
        "name": "defaultOrganization",
        "type": "radio"
      },
      domProps: {
        "checked": entry.default
      },
      on: {
        "change": function($event) {
          _vm.selectDefaultOrganization(entry.organization)
        }
      }
    })])])
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a090162","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/OrganizationManager.vue
// module id = 2035
// module chunks = 0